<div class="report-card report-card--{{ variant }} {{ cssClass }}">
  <div class="report-info">
    @if (report) {
      <div style="font-weight: bold">{{ report.name }}</div>
      <div style="font-size: 0.9em">{{ report._created | date: 'dd.MM.yyyy' }} | {{ report.norm.name }}</div>
      @if (report.species && report.species.length) {
        <div style="font-size: 0.85em">
          {{ 'label_area_tr' | translate }}: {{ report.totalAreaHa }}ha | {{ 'species_tr' | translate }}:
          <app-species-names [codes]="report.species" />
        </div>
      } @else {
        <div style="font-size: 0.85em; color: #ff9800">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle">warning</mat-icon>
          {{ 'no_geodata_tr' | translate }}
        </div>
      }
      @if (articleNumbers && articleNumbers.length > 0) {
        <div style="font-size: 0.85em">{{ 'matching_articles_tr' | translate }}: {{ articleNumbers.join(', ') }}</div>
      }
      <app-site-data-badge
        [producer]="true"
        [hasSpecies]="siteData.hasSpecies"
        [findings]="siteData.findings"
        [severe]="siteData.severe"
      />
      @if (report.id) {
        <div
          class="id-copy"
          (click)="copyIdToClipboard($event)"
          (keydown.enter)="copyIdToClipboard($event)"
          (keydown.space)="copyIdToClipboard($event)"
          title="Copy ID to clipboard"
          tabindex="0"
          role="button"
        >
          ID: {{ report.id }}
        </div>
      }
    } @else if (reportId) {
      <div
        class="id-copy"
        (click)="copyIdToClipboard($event)"
        (keydown.enter)="copyIdToClipboard($event)"
        (keydown.space)="copyIdToClipboard($event)"
        title="Copy ID to clipboard"
        tabindex="0"
        role="button"
      >
        ID: {{ reportId }}
      </div>
    }
  </div>
  @if (action !== 'none' || ((showPreview || showDownload) && report)) {
    <div class="report-card-actions">
      @if (showPreview && report) {
        <button type="button" mat-icon-button color="primary" (click)="onPreviewClick($event)" [title]="'preview_pdf_tr' | translate">
          <mat-icon>visibility</mat-icon>
        </button>
      }
      @if (showDownload && report) {
        <button type="button" mat-icon-button color="primary" (click)="onDownloadClick($event)" [title]="'download_pdf_report_tr' | translate">
          <mat-icon>download</mat-icon>
        </button>
      }
      @if (action !== 'none') {
        <button type="button" mat-icon-button [color]="actionColor" (click)="onActionClick($event)" [disabled]="disabled" [title]="actionTitle | translate">
          <mat-icon>{{ actionIcon }}</mat-icon>
        </button>
      }
    </div>
  }
</div>
